import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Utils } from '../../../../../../utils/utils';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { BranchConfigComponent } from '../branchconfig.component';
import { DefaultValuesService } from '../../../../../../services/defaultvalues.service';
import { KpiStageResultsHistoryPopup } from './kpistageresults-historydialog/kpistageresults-historydialog.component';

@Component({
    selector: 'kpistageresults-popup',
    templateUrl: './kpistageresults-popup.component.html',
    styleUrls: ['./kpistageresults-popup.component.less'],
    standalone: false
})
export class KpiStageResultsPopup implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<KpiStageResultsPopup>,
        private formBuilder: FormBuilder,
        private fb: FormBuilder,
        private http: HttpClient,
        public defaults: DefaultValuesService,
        @Inject('BASE_URL') private baseUrl: string,
        private toastrService: ToastrService,
        private dialogPopUp: MatDialog
    ) {
        this.form = this.fb.group({
            kpiPeriod: [null, Validators.required],
            avOverarchStage: [null, [Validators.required, Validators.min(0.0), Validators.max(4.0)]],
            avSerStage: [null, [Validators.required, Validators.min(0.0), Validators.max(4.0)]],
            avNiStage: [null, [Validators.required, Validators.min(0.0), Validators.max(4.0)]],
            avModStage: [null, [Validators.required, Validators.min(0.0), Validators.max(4.0)]]
        });
    }

    data: AssessmentKpiStageResult = {
        kpiPeriod: undefined,
        avOverarchStage: undefined,
        avSerStage: undefined,
        avNiStage: undefined,
        avModStage: undefined
    }
    form!: FormGroup
    minDate: Date = new Date();

    ngOnInit(): void {         

        Utils.httpGetKpiStageResults(
            this.http
            , this.baseUrl
            , this
            , this.defaults.waveId!
            , function (tthis: KpiStageResultsPopup, result: AssessmentKpiStageResult) {
                tthis.data = result
            },
            null
        )

        this.form = this.formBuilder.group({
            kpiPeriod: [this.data?.kpiPeriod],
            avOverarchStage: [this.data?.avOverarchStage],
            avSerStage: [this.data?.avSerStage],
            avNiStage: [this.data?.avNiStage],
            avModStage: [this.data?.avModStage]
        });
    }

    onSubmit() {
        if (this.form.valid) {
            // Handle form submission
            const formValues = this.form.value;
            const kpistages: AssessmentKpiStageResult = {
                kpiPeriod: formValues.kpiPeriod,
                avOverarchStage: formValues.avOverarchStage,
                avNiStage: formValues.avNiStage,
                avModStage: formValues.avModStage,
                avSerStage: formValues.avSerStage
            };

            Utils.httpUpdateKpiStageResults(
                this.http
                , this.baseUrl
                , this
                , this.defaults.waveId!
                , kpistages
                , function (tthis: KpiStageResultsPopup, result: boolean) {
                    if (result)
                        tthis.toastrService.success(`Kpi Stage Results were updated succesfully!`);
                    else
                        tthis.toastrService.error(`Kpi Stage Results could not be updated. Please, contact with administrator`);
                },
                null
            )

            this.dialogRef.close();
        } else {
            // Highlight errors
            this.form.markAllAsTouched();
        }
    }

    backButtonHandler(event: any) {
        event.preventDefault();
        this.dialogRef.close();
    }

    getDateUTCChange(event, formControlName) {
        let utcDate = Utils.dateUTCchange(event);
        this.form.get(formControlName)?.setValue(utcDate);
    }

    clearDate(controlName: string) {
        this.form.get(controlName)?.setValue(null);
    }

    checkKPIStageResultsHistory($event: any) {
        $event.preventDefault();
        let dialog = this.dialogPopUp.open(KpiStageResultsHistoryPopup, {
            height: '525px',
            width: '1500px',
            data: { WaveId: this.defaults.waveId! }
        });
    }
}
